//Heroku Email Service - CAN send to any recipient
export const sendEmailViaHeroku = async (messageData) => {
  console.log('Attempting to send email via Heroku service...');
  console.log('Message data:', messageData);
  
  try {
    // Your deployed Heroku email service URL
    const herokuUrl = 'https://titledworks-email-service-a54050a2c39f.herokuapp.com';
    
    // Ensure we have a valid email for reply_to
    let replyToEmail = 'hello@titledworks.com'; // default fallback
    
    if (messageData.user && messageData.user.includes('@')) {
      replyToEmail = messageData.user;
    } else if (messageData.from_email && messageData.from_email.includes('@')) {
      replyToEmail = messageData.from_email;
    }
    
    const response = await fetch(`${herokuUrl}/api/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to_email: messageData.recipient,
        from_email: 'hello@titledworks.com',
        message: messageData.message,
        item_id: messageData.itemId,
        subject: `New reply from Titled Works`,
        reply_to: 'hello@titledworks.com',
        user: messageData.user,
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    console.log('Email sent successfully via Heroku:', result);
    return result.success;
  } catch (error) {
    console.error('Error sending email via Heroku:', error);
    return false;
  }
};
